import { render, staticRenderFns } from "./AgencyList.vue?vue&type=template&id=1a77779b&"
import script from "./AgencyList.vue?vue&type=script&lang=js&"
export * from "./AgencyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports